import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

declare global {
  interface Date {
      shift(days: number): Date;
  }
}
Date.prototype.shift = function(days) {
  const d = new Date(this.valueOf());
  d.setDate(d.getDate() + days);
  return d;
};

@Component({
  selector: 'app-day-selector',
  styleUrls: ['day-selector.component.scss'],
  template: `
    <div class="day-selector">
      <div class="day-selector__header">
        <h3 i18n="@@daySelectorComponentHeading">Select days</h3>
        <p><a href="#" (click)="selectAll($event)" i18n="@@daySelectorComponentSelectAll">Select all 7 days</a></p>
      </div>
      <div class="day-selector__content">
        <ul>
          <li *ngFor="let date of dates">
            <app-day-toggler
              [date]="date.date"
              [(ngModel)]="date.selected">
            </app-day-toggler>
          </li>
        </ul>
      </div>
    </div>
  `
})
export class DaySelectorComponent {
  @Input() dates: any[]
  days: any[];

  constructor() {}

  selectAll(evt) {
      if (evt) { evt.preventDefault(); }
      this.dates.map(day => day.selected = true);
  }
  deseletAll(evt) {
      if (evt) { evt.preventDefault(); }
      this.dates.map(day => day.selected = false);
  }
}
